<template>
  <div>
    <v-toolbar class="elevation-0 hide-on-print" color="none">
      <v-toolbar-title class="text-primary">
        <b>{{ visa_request.visa_type.name }}</b>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-card-text class="pt-0">
      <v-layout class="pb-2" row wrap>
        <confirmation-header-text class="ml-2" icon="mdi-equal-box"
                                  text="Visa Details"></confirmation-header-text>
        <v-flex class="mx-2" xs12>
          <v-alert outlined type="error" v-if="visa_request.expired_at">
            This visa has expired.
          </v-alert>
          <v-alert outlined type="error" v-if="!visa_request.expired_at && visa_request.expiry_date < today">
            This visa has expired at {{ visa_request.expiry_date }}.
          </v-alert>
          <!--                    {{visa_request}}-->
          <v-alert outlined type="error" v-if="visa_request.blacklists.length>0">
            Similar record matching to this person information is found in Blacklist.
          </v-alert>
          <v-alert outlined type="info" v-if="visa_request.watch_list.length>0">
            Similar record matching to this person information is found in Watch lists.
          </v-alert>
          <v-alert outlined type="error" v-if="visa_request.cancelled">
            This visa has been cancelled
          </v-alert>
          <!--                    <v-alert outlined type="error" v-if="showLateDays">-->
          <!--                        This visa is <b>{{visa_request.late_days}}</b> days late-->
          <!--                    </v-alert>-->
        </v-flex>
        <v-layout class="pl-6" row wrap>
          <v-flex sm3 xs12>
            <list-item-detail :sub_title="visa_request.visa_number" title="Visa Number"></list-item-detail>
          </v-flex>
          <v-flex sm3 xs12>
            <list-item-detail :sub_title="visa_request.submission_no"
                              title="Submission Id"></list-item-detail>
          </v-flex>
          <v-flex sm3 xs12>
            <list-item-detail
                :sub_title="`${visa_request.start_date.split(' ')[0]} to ${visa_request.expiry_date ?visa_request.expiry_date:expiryDate}`  "
                title="Visa Duration"/>
          </v-flex>
          <v-flex sm3 v-if="visa_request.expired_at" xs12>
            <list-item-detail
                :sub_title="visa_request.expired_at"
                title="Visa Expired Date"/>
          </v-flex>

          <v-flex sm3 v-if="visa_request.approved_at" xs12>
            <list-item-detail
                :sub_title="visa_request.approved_at"
                title="Visa Approved Date"/>
          </v-flex>
        </v-layout>

        <black-list-detail :black_lists="visa_request.blacklists" :traveller_id="visa_request.traveller.id"
                           @unmarked="unmarked"/>

        <v-flex xs12>
          <component v-bind:is="visa_type_slug"></component>
        </v-flex>

        <v-flex xs12>
          <v-divider class="mb-2"></v-divider>
        </v-flex>

        <v-layout class="pl-6" row v-if="visa_request.extra.previous_visa" wrap>

          <v-flex sm3 xs12>
            <list-item-detail :sub_title="visa_request.previous_visa.visa_number"
                              title="Visa number"></list-item-detail>
          </v-flex>

          <v-flex sm3 xs12>
            <list-item-detail :sub_title="visa_request.previous_visa.visa_type"
                              title="Visa Type"></list-item-detail>
          </v-flex>

          <v-flex sm3 xs12>
            <list-item-detail :sub_title="visa_request.previous_visa.expiry_date"
                              title="Expiry date"></list-item-detail>
          </v-flex>

          <v-flex xs12>
            <v-divider class="mb-3"></v-divider>
          </v-flex>
        </v-layout>
        <traveller-detail :mobile_number="visa_request.extra.mobile_number"/>


        <v-flex xs12>
          <v-divider class="my-3"></v-divider>
        </v-flex>

        <attached-document :document_list="visa_request.documents" :is_latest="visa_request.isLatestVisa"
                           :visa_number="visa_request.visa_number"
                           :submission_number="visa_request.submission_no"
                           v-if="visa_request.documents"></attached-document>

        <v-layout class="mx-0" row v-if="paidTrack">
          <v-flex xs12>
            <v-divider class="mb-2"></v-divider>
          </v-flex>

          <v-flex class="pa-2" lg12 md12 sm12>
            <confirmation-header-text class="pl-3" icon="mdi-alpha-p-box"
                                      text="Payment Info"></confirmation-header-text>
          </v-flex>

          <v-flex xs3>
            <list-item-detail :sub_title="paidTrack.extra.invoice_number"
                              title="Invoice number"></list-item-detail>
          </v-flex>

          <v-flex xs3>
            <list-item-detail :sub_title="paidTrack.date+' '+paidTrack.time"
                              title="Paid on"></list-item-detail>
          </v-flex>
        </v-layout>

      </v-layout>
      <v-footer class="sticky" color="blue darken-1" fixed height="auto">
        <v-layout row wrap>
          <v-spacer/>
          <v-btn
              @click="attachDocument"
              class="white--text"
              color="primary ml-2"
              v-if="visa_request.can_attach_file"
          >
            Attach Document(s)
          </v-btn>
          <v-btn
              @click="cancel"
              class="white--text"
              color="red lighten-1 ml-2"
              v-if="  visa_request.visa_number && !visa_request.cancelled && visa_request.can_approve_visa                      "
          >
            Cancel Visa
          </v-btn>
        </v-layout>
      </v-footer>
      <visa-cancel-modal/>
      <attach-file-dialog
          :url="'visa-requests/attach-file/'+visa_request.submission_no"
          @attached="costExempted"
          v-model="attachFileDialog"
          :file-already-attached="fileAlreadyAttached"
      />
    </v-card-text>

  </div>
</template>
<script>
import {mapActions} from 'vuex'
import ListItemDetail from "../../../components/ListItemDetail";
import {SET_SELECTED_TIPPANI} from "../../../store/mutation-type";
import ExtendConvertTippaniPrintContent from "../../../components/visa/ExtendConvertTippaniPrintContent";
import FileListItemDetail from "../../../components/FileListItemDetail";
import AttachedDocument from "../../../components/AttachedDocument";
import AttachFileDialog from "../../../components/dialogs/AttachFileDialog";


import TouristVisa from "@/components/visa-types/confirm/TouristVisa";
import StudyVisa from "@/components/visa-types/confirm/StudyVisa";
import BusinessVisa from "@/components/visa-types/confirm/BusinessVisa";
import RelationVisa from "@/components/visa-types/confirm/RelationVisa";
import TransitVisa from "@/components/visa-types/confirm/TransitVisa";
import OfficialVisa from "@/components/visa-types/confirm/OfficialVisa";
import DiplomaticVisa from "@/components/visa-types/confirm/DiplomaticVisa";
import MarriageVisa from "@/components/visa-types/confirm/MarriageVisa";
import ResidentialVisa from "@/components/visa-types/confirm/ResidentialVisa";
import NRNVisa from "@/components/visa-types/confirm/NRNVisa";
import PressVisa from "@/components/visa-types/confirm/PressVisa";
import DependentVisa from "../../../components/visa-types/confirm/DependentVisa";
import FileDisplay from "../../../components/FileDisplay";
import ConfirmationHeaderText from "../../../components/ConfirmationHeaderText";
import WorkingVisa from "../../../components/visa-types/confirm/WorkingVisa";
import BlackListDetail from "../../../components/visa/BlackListDetail";
import TravellerDetail from "./TravellerDetail";
import VisaCancelModal from "../../../components/visa/VisaCancelModal";
import moment from "moment";

export default {
  name: "OldVisaDetail",
  props: ['visa_request', 'voucherLoading', 'checkPaymentLoading'],
  components: {
    ListItemDetail,
    FileDisplay,
    ExtendConvertTippaniPrintContent,
    BlackListDetail,
    TravellerDetail,
    ConfirmationHeaderText,
    "tourist-visa": TouristVisa,
    'study-visa': StudyVisa,
    'business-visa': BusinessVisa,
    'relation-visa': RelationVisa,
    'transit-visa': TransitVisa,
    'marriage-visa': MarriageVisa,
    'residential-visa': ResidentialVisa,
    'diplomatic-visa': DiplomaticVisa,
    'official-visa': OfficialVisa,
    'nrn-visa': NRNVisa,
    'dependent-visa': DependentVisa,
    'working-visa': WorkingVisa,
    'press-visa': PressVisa, FileListItemDetail,
    VisaCancelModal, AttachedDocument, AttachFileDialog
  },
  data() {
    return {
      voucherNumber: null,
      tippaniDialog: false,
      step: 1,
      quill: null,
      approvedTrack: null,
      hide: false,
      attachFileDialog: false,
      today: moment().format('YYYY-MM-DD'),
    }
  },
  computed: {
    documents() {
      let passport = this.visa_request.traveller_document;
      let documents = [];
      if (passport) {
        documents =
            [{
              type: 'passport',
              number: passport.document_number,
              validity: passport.validity
            }];
      }
      return documents;
    },
    visa_type_slug() {
      if (this.visa_request.dependent_visa.full_name !== undefined) {
        return "dependent-visa"
      }
      if (this.visa_request.dependent_visa === 1) {
        return 'dependent-visa';
      }

      return this.visa_request.visa_type.slug;
    },

    viewTravellerHistory() {
      return !!this.visa_request.traveller.id;
    },

    getAppliedTrack() {
      return this.visa_request.visaHistory.find(track => track.status === 0)
    },

    paidTrack() {
      let track = this.visa_request.visaHistory.find((t) => t.status === 1);
      console.log(track);
      if (track) {
        if (track.extra.invoice_number || track.amount)
          return track;

      }
      return false;
    },

    getApprovedTrack() {
      if (!this.approvedTrack) {
        this.approvedTrack = this.visa_request.visaHistory.find(track => track.status === 2)
      }
      return this.approvedTrack
    },

    getApprovedExtraVerifiedDetail() {
      // console.log(this.getApprovedTrack.extra.verified_by)
      // console.log(JSON.parse(this.getApprovedTrack.extra.verified_by));
      // return {
      //
      // }
      return JSON.parse(this.getApprovedTrack.extra.verified_by);
    },

    selectedTippani: {
      get() {
        return this.$store.state.Tippani.selectedTippani;
      },
      set(value) {
        this.$store.commit(SET_SELECTED_TIPPANI, value)
      }
    },
    fileAlreadyAttached() {
      const {file_attached} = this.visa_request;
      return file_attached;
    },
  },
  methods: {
    ...mapActions('VisaRequestSingle', [
      'getVisaRequestDetail', 'makePayment', 'submitTippani', 'checkPaymentStatus', 'generateVoucher']),
    view(submission_no) {
      window.open('/admin/system/visa-requests/view/' + submission_no, '_blank')
    },
    viewHistory(item) {
      window.open('/admin/system/travellers-history/view/' + item.traveller.id, '_blank');
    },
    cancel() {
      this.$store.commit("VisaRequestSingle/setCancelModal", true);
    },
    attachDocument() {
      this.attachFileDialog = true;
    },
    costExempted() {
      this.getVisaRequestDetail(this.visa_request.submission_no)
    },
    unmarked(id) {
      this.visa_request.blacklists = this.visa_request.blacklists.filter((i) => i.id === id);
    },

  }
}
</script>
